const Request = {
  DBInfo: "/Tables/FrequentlyAsk/Info",
  List: "/Tables/FrequentlyAsk/List",
  Info: "/Tables/FrequentlyAsk/Get",
  Add: "/Tables/FrequentlyAsk/Add",
  Delete: "/Tables/FrequentlyAsk/Delete",
  Edit: "/Tables/FrequentlyAsk/Edit",
  Export: "/Tables/FrequentlyAsk/Export",
};

let exports = {
  Request,
};

export default exports;
